var _rect, _mask, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 42,
    viewBox: "0 0 62 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 61,
    height: 41,
    rx: 5.5,
    fill: "white",
    stroke: "#ECEDF1"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 60,
    height: 40
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 60,
    height: 40,
    rx: 5,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.9396 2.1231C71.9591 19.9416 68.0792 36.5764 -12.9158 38.9605C-5.44252 44.1972 3.21089 48.019 12.7423 49.9198C47.6712 56.8851 81.6144 35.7078 90.9396 2.1231Z",
    fill: "#F26E21"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9505 25.2773C35.2865 25.2773 37.1802 23.4244 37.1802 21.1387C37.1802 18.8529 35.2865 17 32.9505 17C30.6144 17 28.7207 18.8529 28.7207 21.1387C28.7207 23.4244 30.6144 25.2773 32.9505 25.2773Z",
    fill: "#F26E21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1668 23.1198C9.6684 23.5564 9.02526 23.7456 8.0039 23.7456H7.58011V18.5496H8.0039C9.02512 18.5496 9.6429 18.7264 10.1668 19.1853C10.713 19.6566 11.0388 20.3863 11.0388 21.1402C11.0388 21.8945 10.713 22.6499 10.1668 23.1198ZM8.32066 17.2189H6V25.0751H8.30899C9.53437 25.0751 10.4201 24.794 11.1972 24.1683C12.119 23.4263 12.6663 22.3073 12.6663 21.1505C12.6661 18.8311 10.8805 17.2189 8.32066 17.2189Z",
    fill: "#0B161F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.397 25.0759H14.9746V17.2197H13.397V25.0759Z",
    fill: "#0B161F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8343 20.2329C17.8861 19.8916 17.6069 19.6672 17.6069 19.2451C17.6069 18.7498 18.1038 18.3729 18.7845 18.3729C19.2581 18.3729 19.6459 18.5611 20.0606 19.0076L20.8845 17.9606C20.2054 17.3825 19.3921 17.0884 18.5049 17.0884C17.0735 17.0884 15.9801 18.0544 15.9801 19.3368C15.9801 20.422 16.4892 20.9753 17.9714 21.4948C18.5907 21.7058 18.9054 21.8464 19.0637 21.9422C19.379 22.1429 19.5378 22.4245 19.5378 22.7543C19.5378 23.3916 19.0155 23.8618 18.3104 23.8618C17.5576 23.8618 16.9511 23.4974 16.5866 22.8139L15.5684 23.7689C16.2952 24.804 17.1694 25.2654 18.3723 25.2654C20.0107 25.2654 21.1635 24.2035 21.1635 22.6847C21.1642 21.4353 20.6312 20.8696 18.8343 20.2329Z",
    fill: "#0B161F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.664 21.1511C21.664 23.4625 23.534 25.253 25.938 25.253C26.6181 25.253 27.1998 25.1224 27.917 24.7945V22.9902C27.2852 23.6036 26.7262 23.8505 26.01 23.8505C24.4197 23.8505 23.2904 22.731 23.2904 21.1402C23.2904 19.6329 24.4558 18.4424 25.938 18.4424C26.6892 18.4424 27.2607 18.7011 27.917 19.326V17.523C27.2257 17.1823 26.6537 17.0417 25.9735 17.0417C23.5826 17.0423 21.664 18.8684 21.664 21.1511Z",
    fill: "#0B161F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7093 22.4968L38.5479 17.2197H36.8241L40.2611 25.2771H41.1097L44.6071 17.2197H42.895L40.7093 22.4968Z",
    fill: "#0B161F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.324 25.0759H49.803V23.7464H46.9021V21.6237H49.6919V20.2941H46.9021V18.5502H49.803V17.2197H45.324V25.0759Z",
    fill: "#0B161F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8856 20.8359H52.4258V18.4549H52.9105C53.8957 18.4549 54.4302 18.8572 54.4302 19.6215C54.4302 20.4102 53.8957 20.8359 52.8856 20.8359ZM56.054 19.5382C56.054 18.0665 55.011 17.2197 53.1887 17.2197H50.8462V25.0759H52.4254V21.9186H52.6325L54.8162 25.0759H56.7588L54.2082 21.7661C55.3998 21.5308 56.054 20.7406 56.054 19.5382Z",
    fill: "#0B161F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.df7b2ab33c05ee7056de30ad6ca2e22a.svg";
export { ForwardRef as ReactComponent };